import api from './api';
import { ApiResponse, unwrapApiResponse } from '@/utils/api-response.util';

const BASE_URL = '/calculated-metrics';

export interface MetricInfoResponse {
  name: string;
  /** Назва метрики мовою інтерфейсу (напр. «Базальний рівень метаболізму»). */
  caption: string;
  description: string;
  requiredParams: string[];
  sources: string[];
  explanation: string;
  path: string;
}

export const getAvailableMetrics = async (): Promise<string[]> => {
  const response = await api.get<ApiResponse<string[]>>(`${BASE_URL}`);
  return unwrapApiResponse(response);
};

export const getMetricInfo = async (metric: string): Promise<MetricInfoResponse> => {
  const response = await api.get<ApiResponse<MetricInfoResponse>>(`${BASE_URL}/${metric}/info`);
  return unwrapApiResponse(response);
};

export const calculateMetric = async (metric: string, body: any): Promise<any> => {
  const response = await api.post<ApiResponse<any>>(`${BASE_URL}/${metric}/calculate`, body);
  return unwrapApiResponse(response);
};
